import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { clientAPI } from "../api/client";
import { NumberOfPerPage } from "../utils/globalVariable";
import { formatDateForInput, formatDate } from "../utils/utils";
import { formatDateDb } from "../utils/tools";

const NUMBER_NFT_PER_PAGE = NumberOfPerPage.onLeave;
const queryKey = "CustomerList";
const jobQueryKey = "JobList";
const projectQueryKey = "ProjectList";
const customerTypeQueryKey = "CustomerTypeList";

// TODO: list
async function fetchAllData(
  search,
  fetchOptions = {
    job: false,
    employee: false,
    project: false,
    customerType: false,
  }
) {
  const searchOptions = {
    limit: 100000,
    page: 1,
  };

  if (search !== undefined) searchOptions.search = search;

  const promises = [];

  if (fetchOptions.job) {
    const options = {
      ...searchOptions,
    };
    const searchQueryParams = new URLSearchParams(options).toString();
    promises.push(
      clientAPI("get", `/job?${searchQueryParams}`).then((data) =>
        data?.items?.reduce(
          (acc, item) => ({ ...acc, [item._id]: item.name }),
          {}
        )
      )
    );
  } else {
    promises.push(Promise.resolve(null));
  }

  if (fetchOptions.employee) {
    const options = {
      ...searchOptions,
    };
    const searchQueryParams = new URLSearchParams(options).toString();
    promises.push(
      clientAPI("get", `/employee/search?${searchQueryParams}`).then((data) =>
        data?.items?.reduce(
          (acc, item) => ({ ...acc, [item._id]: item.fullName }),
          {}
        )
      )
    );
  } else {
    promises.push(Promise.resolve(null));
  }

  if (fetchOptions.project) {
    const options = {
      ...searchOptions,
    };
    options.status = "OPEN";
    const searchQueryParams = new URLSearchParams(options).toString();
    promises.push(
      clientAPI("get", `/project?${searchQueryParams}`).then((data) =>
        data?.items?.reduce(
          (acc, item) => ({ ...acc, [item._id]: item.name }),
          {}
        )
      )
    );
  } else {
    promises.push(Promise.resolve(null));
  }

  if (fetchOptions.customerType) {
    const options = {
      limit: 100,
      page: 1,
    };
    const searchQueryParams = new URLSearchParams(options).toString();
    promises.push(
      clientAPI("get", `/customerType?${searchQueryParams}`).then((data) =>
        data?.items?.reduce(
          (acc, item) => ({ ...acc, [item._id]: item.name }),
          {}
        )
      )
    );
  } else {
    promises.push(Promise.resolve(null));
  }

  const [jobList, employeeList, projectList, customerTypeList] =
    await Promise.all(promises);

  return {
    jobList,
    employeeList,
    projectList,
    customerTypeList,
  };
}

export function useConditionalLists2(search, fetchOptions) {
  const { data, isLoading, isFetching, refetch } = useQuery({
    queryKey: ["conditionalLists2", search, fetchOptions],
    queryFn: () => fetchAllData(search, fetchOptions),
    refetchOnWindowFocus: false,
    staleTime: 30000,
    keepPreviousData: true,
    onError: (error) => {
      console.error("Error fetching conditional lists data:", error);
    },
  });

  return {
    jobList: data?.jobList,
    employeeList: data?.employeeList,
    projectList: data?.projectList,
    customerTypeList: data?.customerTypeList,
    isLoading,
    isFetching,
    refetch,
  };
}

//TODO: customer List
const initData = {
  data: [],
  totalpages: 0,
  entries: 0,
  startEntry: 0,
  endEntry: 0,
  exportData: [],
};
async function fetchCustomerList(
  currentPage,
  search,
  wishlist,
  employeeId,
  status
) {
  try {
    const options = {
      limit: NUMBER_NFT_PER_PAGE,
      page: currentPage,
    };

    if (search !== undefined) options.search = search;
    if (wishlist) options.wishlist = wishlist;
    if (employeeId) options.employeeId = employeeId;
    if (status) options.status = status;

    const queryParams = new URLSearchParams(options).toString();
    let data = await clientAPI("get", `/customerUpdateRequest/?${queryParams}`);
    const totalPages = Math.ceil(data?.pagination?.total / NUMBER_NFT_PER_PAGE);
    const entries = data?.pagination?.total;
    const startEntry =
      (data?.pagination?.page - 1) * data?.pagination?.limit + 1;
    const endEntry = Math.min(
      data?.pagination?.page * data?.pagination?.limit,
      entries
    );

    const newData = data?.items.map((item, index) => {
      let permanentAddress = item?.permanentAddress || "";
      if (item.permanentAddressWardData) {
        permanentAddress += ", ";
        permanentAddress += item.permanentAddressWardData?.name;
      }
      if (item.permanentAddressDistrictData) {
        permanentAddress += " - ";
        permanentAddress += item.permanentAddressDistrictData?.name;
      }
      if (item.permanentAddressProvinceData) {
        permanentAddress += " - ";
        permanentAddress += item.permanentAddressProvinceData?.name;
      }

      let currentAddress = item?.currentAddress || "";
      if (item.currentAddressWardData) {
        currentAddress += ", ";
        currentAddress += item.currentAddressWardData?.name;
      }
      if (item.currentAddressDistrictData) {
        currentAddress += " - ";
        currentAddress += item.currentAddressDistrictData?.name;
      }
      if (item.currentAddressProvinceData) {
        currentAddress += " - ";
        currentAddress += item.currentAddressProvinceData?.name;
      }

      let genderData = "-";
      if (item?.gender) {
        if (item?.gender === 1) {
          genderData = "Nam";
        } else if (item?.gender === 2) {
          genderData = "Nữ";
        } else {
          genderData = "Khác";
        }
      }

      let genderDataOld = "-";
      if (item?.genderOld) {
        if (item?.genderOld === 1) {
          genderDataOld = "Nam";
        } else if (item?.gender === 2) {
          genderDataOld = "Nữ";
        } else {
          genderDataOld = "Khác";
        }
      }

      let identityData = 'CCCD/CMND';
      if (item?.identityNumber) {
        if (item?.identityNumber === 2) {
          identityData = "Hộ chiếu";
        } else {
          identityData = "CCCD/CMND";
        }
      }
       let identityDataOld = 'CCCD/CMND';
      if (item?.identityNumberOld) {
        if (item?.identityNumberOld === 2) {
          identityDataOld = "Hộ chiếu";
        } else {
          identityDataOld = "CCCD/CMND";
        }
      }

      return {
        ...(item?._id && { id: item._id }),
        name: item?.name || "-",
        gender: !item?.isBusiness ? genderData : "-",
        status: item?.status || "PENGDING",
        isBusiness: item?.isBusiness ? 1 : 0,
        businessTaxCode: item?.businessTaxCode || "-",
        businessRegistrationImage: item?.businessRegistrationImage || [],
        dateOfBirth: item?.dateOfBirth || "-",
        contact: {
          phone: item?.phone || "-",
          email: item?.email || "-",
        },
        identityNumber: identityData,
        identificationNumber: item?.identificationNumber || "-",
        identificationInfo: {
          dateOfIdentification: item?.dateOfIdentification || "-",
          placeOfIdentification: item?.placeOfIdentification || "-",
        },
        idCardFrontImage: item?.idCardFrontImage,
        idCardBackImage: item?.idCardBackImage,
        vnidImage: item?.vnidImage,
        permanentAddress: permanentAddress || "-",
        currentAddress: currentAddress || "-",
        career: item?.job?.name || "-",
        project: item?.wishlistDetail
          ? item?.wishlistDetail?.map((item) => item?.name)
          : [],

        businessRegistrationPlace: item?.businessRegistrationPlace || "-",
        businessAddress: item?.businessAddress || "-",
        businessLocationAddress: item?.businessLocationAddress || "-",
        businessRegistrationDate: item?.businessRegistrationDate || "",
        representativeName: item?.representativeName || "-",
        representativeGender: item?.isBusiness ? genderData : "-",
        representativeIdNumber: item?.representativeIdNumber || "-",
        representativeIdIssuedDate: item?.representativeIdIssuedDate || "-",
        representativeIdIssuedPlace: item?.representativeIdIssuedPlace || "-",
        idRepresentativeCardFrontImage: item?.idRepresentativeCardFrontImage,
        idRepresentativeCardBackImage: item?.idRepresentativeCardBackImage,
        representativeVnidImage: item?.representativeVnidImage,
        representativePosition: item?.representativePosition || "-",
        type: item?.customerType?.name || "-",
        employee: item?.employee?.fullName || "-",
        dateCreate: item?.createdAt ? formatDateDb(item?.createdAt) : "-",
        edit: {
          ...(item?._id && { id: item._id }),
          ...(item?.name && { name: item.name }),
          ...(item?.gender && { gender: item.gender }),
          status: item?.status || "PENGDING",
          ...(item?.phone && { phone: item.phone }),
          ...(item?.email && { email: item.email }),
          ...(item?.identificationNumber && {
            identificationNumber: item.identificationNumber,
          }),
          ...(item?.dateOfIdentification && {
            dateOfIdentification: formatDateForInput(
              formatDate(item.dateOfIdentification)
            ),
          }),
          ...(item?.dateOfBirth && {
            dateOfBirth: formatDateForInput(formatDate(item.dateOfBirth)),
          }),
          ...(item?.placeOfIdentification && {
            placeOfIdentification: item.placeOfIdentification,
          }),
          ...(item?.permanentAddress && {
            permanentAddress: item.permanentAddress,
          }),
          ...(item?.permanentAddressProvince && {
            permanentAddressProvince: item.permanentAddressProvince,
          }),
          ...(item?.permanentAddressDistrict && {
            permanentAddressDistrict: item.permanentAddressDistrict,
          }),
          ...(item?.permanentAddressWard && {
            permanentAddressWard: item.permanentAddressWard,
          }),
          ...(item?.currentAddress && { currentAddress: item.currentAddress }),
          ...(item?.currentAddressDistrict && {
            currentAddressDistrict: item.currentAddressDistrict,
          }),
          ...(item?.currentAddressProvince && {
            currentAddressProvince: item.currentAddressProvince,
          }),
          ...(item?.currentAddressWard && {
            currentAddressWard: item.currentAddressWard,
          }),
          ...(item?.jobId && {
            jobId: item.jobId,
          }),
          ...(item?.customerTypeId && { customerTypeId: item.customerTypeId }),
          ...(item?.wishlist && { wishlist: item.wishlist }),
          ...(item?.bankAccount && { bankAccount: item.bankAccount }),
          ...(item?.bankName && { bankName: item.bankName }),
          ...(item?.nameAccount && { nameAccount: item.nameAccount }),

          isBusiness: item.isBusiness || false,
          ...(item?.businessTaxCode && {
            businessTaxCode: item.businessTaxCode,
          }),
          ...(item?.businessRegistrationPlace && {
            businessRegistrationPlace: item.businessRegistrationPlace,
          }),
          ...(item?.representativeName && {
            representativeName: item.representativeName,
          }),
          ...(item?.representativeIdNumber && {
            representativeIdNumber: item.representativeIdNumber,
          }),
          ...(item?.representativeIdIssuedDate && {
            representativeIdIssuedDate: formatDateForInput(
              formatDate(item.representativeIdIssuedDate)
            ),
          }),
          ...(item?.representativeIdIssuedPlace && {
            representativeIdIssuedPlace: item.representativeIdIssuedPlace,
          }),
          ...(item?.representativePosition && {
            representativePosition: item.representativePosition,
          }),

          ...(item?.employeeId && { employeeId: item.employeeId }),

          idCardFrontImage: item?.idCardFrontImage || "",
          idCardFrontImageOld: item?.idCardFrontImageOld || "",

          idCardBackImage: item?.idCardBackImage || "",
          idCardBackImageOld: item?.idCardBackImageOld || "",

          vnidImage: item?.vnidImage || "",
          vnidImageOld: item?.vnidImageOld || "",

          idRepresentativeCardFrontImage:
            item?.idRepresentativeCardFrontImage || "",
          idRepresentativeCardFrontImageOld:
            item?.idRepresentativeCardFrontImageOld || "",

          idRepresentativeCardBackImage:
            item?.idRepresentativeCardBackImage || "",
          idRepresentativeCardBackImageOld:
            item?.idRepresentativeCardBackImageOld || "",

          representativeVnidImage:
            item?.representativeVnidImage || "",
          representativeVnidImageOld:
            item?.representativeVnidImageOld || "",

          businessAddress: item?.businessAddress || "",
          businessAddressOld: item?.businessAddressOld || "",

          businessLocationAddress: item?.businessLocationAddress || "",
          businessLocationAddressOld: item?.businessLocationAddressOld || "",

          businessRegistrationDate: item?.businessRegistrationDate || "",
          businessRegistrationDateOld: item?.businessRegistrationDateOld || "",
        },
        detail: {
          ...(item?._id && { id: item._id }),
          ...(item?.name && { name: item.name }),
          ...(item?.gender && { gender: genderData }),
          status: item?.status || "PENGDING",
          ...(item?.phone && { phone: item.phone }),
          ...(item?.email && { email: item.email }),
          identityNumber: identityData,
          ...(item?.identificationNumber && {
            identificationNumber: item.identificationNumber,
          }),
          ...(item?.dateOfIdentification && {
            dateOfIdentification: item.dateOfIdentification,
          }),
          ...(item?.dateOfIdentification && {
            dateOfIdentification: item.dateOfIdentification,
          }),
          ...(item?.dateOfBirth && {
            dateOfBirth: item.dateOfBirth,
          }),
          ...(item?.permanentAddress && {
            permanentAddress: item.permanentAddress,
          }),
          ...(item?.permanentAddressProvinceData && {
            permanentAddressProvinceData: item.permanentAddressProvinceData,
          }),
          ...(item?.permanentAddressDistrictData && {
            permanentAddressDistrictData: item.permanentAddressDistrictData,
          }),
          ...(item?.permanentAddressWardData && {
            permanentAddressWardData: item.permanentAddressWardData,
          }),
          ...(item?.currentAddress && { currentAddress: item.currentAddress }),
          ...(item?.currentAddressDistrictData && {
            currentAddressDistrictData: item.currentAddressDistrictData,
          }),
          ...(item?.currentAddressProvinceData && {
            currentAddressProvinceData: item.currentAddressProvinceData,
          }),
          ...(item?.currentAddressWardData && {
            currentAddressWardData: item.currentAddressWardData,
          }),
          ...(item?.job && {
            job: item.job?.name,
          }),
          ...(item?.customerType && { customerType: item.customerType?.name }),
          ...(item?.wishlistDetail && { wishlistDetail: item.wishlistDetail }),
          ...(item?.bankAccount && { bankAccount: item.bankAccount }),
          ...(item?.bankName && { bankName: item.bankName }),
          ...(item?.nameAccount && { nameAccount: item.nameAccount }),

          isBusiness: item.isBusiness || false,
          ...(item?.businessTaxCode && {
            businessTaxCode: item.businessTaxCode,
          }),
          ...(item?.businessRegistrationPlace && {
            businessRegistrationPlace: item.businessRegistrationPlace,
          }),
          ...(item?.representativeName && {
            representativeName: item.representativeName,
          }),
          ...(item?.representativeIdNumber && {
            representativeIdNumber: item.representativeIdNumber,
          }),
          ...(item?.representativeIdIssuedDate && {
            representativeIdIssuedDate: item.representativeIdIssuedDate,
          }),
          ...(item?.representativeIdIssuedPlace && {
            representativeIdIssuedPlace: item.representativeIdIssuedPlace,
          }),
          ...(item?.representativePosition && {
            representativePosition: item.representativePosition,
          }),
          //old
          ...(item?.nameOld && { nameOld: item.nameOld }),
          ...(item?.genderOld && { genderOld: genderDataOld }),
          ...(item?.phoneOld && { phoneOld: item.phoneOld }),
          ...(item?.emailOld && { emailOld: item.emailOld }),
          identityNumberOld: identityDataOld,
          ...(item?.identificationNumberOld && {
            identificationNumberOld: item.identificationNumberOld,
          }),
          ...(item?.dateOfIdentificationOld && {
            dateOfIdentificationOld: item.dateOfIdentificationOld,
          }),
          ...(item?.dateOfIdentificationOld && {
            dateOfIdentificationOld: item.dateOfIdentificationOld,
          }),
          ...(item?.dateOfBirthOld && {
            dateOfBirthOld: item.dateOfBirthOld,
          }),
          ...(item?.permanentAddressOld && {
            permanentAddressOld: item.permanentAddressOld,
          }),
          ...(item?.permanentAddressProvinceDataOld && {
            permanentAddressProvinceDataOld:
              item.permanentAddressProvinceDataOld,
          }),
          ...(item?.permanentAddressDistrictDataOld && {
            permanentAddressDistrictDataOld:
              item.permanentAddressDistrictDataOld,
          }),
          ...(item?.permanentAddressWardDataOld && {
            permanentAddressWardDataOld: item.permanentAddressWardDataOld,
          }),
          ...(item?.currentAddressOld && {
            currentAddressOld: item.currentAddressOld,
          }),
          ...(item?.currentAddressDistrictDataOld && {
            currentAddressDistrictDataOld: item.currentAddressDistrictDataOld,
          }),
          ...(item?.currentAddressProvinceDataOld && {
            currentAddressProvinceDataOld: item.currentAddressProvinceDataOld,
          }),
          ...(item?.currentAddressWardDataOld && {
            currentAddressWardDataOld: item.currentAddressWardDataOld,
          }),
          ...(item?.jobOld && {
            jobOld: item.jobOld?.name,
          }),
          ...(item?.customerTypeOld && {
            customerTypeOld: item.customerTypeOld?.name,
          }),
          ...(item?.wishlistDetailOld && {
            wishlistDetailOld: item.wishlistDetailOld,
          }),
          ...(item?.bankAccountOld && { bankAccountOld: item.bankAccountOld }),
          ...(item?.bankNameOld && { bankNameOld: item.bankNameOld }),
          ...(item?.nameAccountOld && { nameAccountOld: item.nameAccountOld }),
          isBusinessOld: item.isBusinessOld || false,
          ...(item?.businessTaxCodeOld && {
            businessTaxCodeOld: item.businessTaxCodeOld,
          }),
          ...(item?.businessRegistrationPlaceOld && {
            businessRegistrationPlaceOld: item.businessRegistrationPlaceOld,
          }),
          ...(item?.representativeNameOld && {
            representativeNameOld: item.representativeNameOld,
          }),
          ...(item?.representativeIdNumberOld && {
            representativeIdNumberOld: item.representativeIdNumberOld,
          }),
          ...(item?.representativeIdIssuedDateOld && {
            representativeIdIssuedDateOld: item.representativeIdIssuedDateOld,
          }),
          ...(item?.representativeIdIssuedPlaceOld && {
            representativeIdIssuedPlaceOld: item.representativeIdIssuedPlaceOld,
          }),
          ...(item?.representativePositionOld && {
            representativePositionOld: item.representativePositionOld,
          }),
          ...(item?.placeOfIdentification && {
            placeOfIdentification: item.placeOfIdentification,
          }),
          ...(item?.placeOfIdentificationOld && {
            placeOfIdentificationOld: item.placeOfIdentificationOld,
          }),
          ...(item?.approver && { approver: item.approver }),

          idCardFrontImage: item?.idCardFrontImage || "",
          idCardFrontImageOld: item?.idCardFrontImageOld || "",

          idCardBackImage: item?.idCardBackImage || "",
          idCardBackImageOld: item?.idCardBackImageOld || "",

          vnidImage: item?.vnidImage || "",
          vnidImageOld: item?.vnidImageOld || "",

          idRepresentativeCardFrontImage:
            item?.idRepresentativeCardFrontImage || "",
          idRepresentativeCardFrontImageOld:
            item?.idRepresentativeCardFrontImageOld || "",

          idRepresentativeCardBackImage:
            item?.idRepresentativeCardBackImage || "",
          idRepresentativeCardBackImageOld:
            item?.idRepresentativeCardBackImageOld || "",

          representativeVnidImage:
            item?.representativeVnidImage || "",
          representativeVnidImageOld:
            item?.representativeVnidImageOld || "",

          businessAddress: item?.businessAddress || "",
          businessAddressOld: item?.businessAddressOld || "",

          businessLocationAddress: item?.businessLocationAddress || "",
          businessLocationAddressOld: item?.businessLocationAddressOld || "",

          businessRegistrationDate: item?.businessRegistrationDate || "",
          businessRegistrationDateOld: item?.businessRegistrationDateOld || "",
        },
      };
    });

    const exportData = data?.items.map((item, index) => {
      let permanentAddress = item?.permanentAddress || "";
      if (item.permanentAddressWardData) {
        permanentAddress += ", ";
        permanentAddress += item.permanentAddressWardData?.name;
      }
      if (item.permanentAddressDistrictData) {
        permanentAddress += " - ";
        permanentAddress += item.permanentAddressDistrictData?.name;
      }
      if (item.permanentAddressProvinceData) {
        permanentAddress += " - ";
        permanentAddress += item.permanentAddressProvinceData?.name;
      }

      let currentAddress = item?.currentAddress || "";
      if (item.currentAddressWardData) {
        currentAddress += ", ";
        currentAddress += item.currentAddressWardData?.name;
      }
      if (item.currentAddressDistrictData) {
        currentAddress += " - ";
        currentAddress += item.currentAddressDistrictData?.name;
      }
      if (item.currentAddressProvinceData) {
        currentAddress += " - ";
        currentAddress += item.currentAddressProvinceData?.name;
      }
      return {
        name: item?.name || "-",
        dateOfBirth: item?.dateOfBirth || "-",
        phone: item?.phone || "-",
        email: item?.email || "-",
        identificationNumber: item?.identificationNumber || "-",
        dateOfIdentification: item?.dateOfIdentification || "-",
        placeOfIdentification: item?.placeOfIdentification || "-",
        permanentAddress: permanentAddress || "-",
        currentAddress: currentAddress || "-",
        career: item?.job?.name || "-",
        project: item?.wishlistDetail
          ? item?.wishlistDetail
              ?.map((item) => item?.name)
              .filter(Boolean)
              .join(", ")
          : "-",
        type: item?.customerType?.name || "-",
        employee: item?.employee?.fullName || "-",
        dateCreate: item?.createdAt ? formatDateDb(item?.createdAt) : "-",
      };
    });
    return {
      data: newData,
      totalPages,
      entries,
      startEntry,
      endEntry,
      exportData,
    };
  } catch (error) {
    console.error("Error fetching onLeave data:", error);
    return initData;
  }
}

export function useCustomerUpdateRequestList(
  search,
  wishlist,
  employeeId,
  status
) {
  const [currentPage, setCurrentPage] = useState(1);
  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [
      "useCustomerUpdateRequestList",
      currentPage,
      search,
      wishlist,
      employeeId,
      status,
    ],
    queryFn: () =>
      fetchCustomerList(currentPage, search, wishlist, employeeId, status),
    refetchOnWindowFocus: false,
    staleTime: 30000,
    keepPreviousData: true,
    onError: (error) => {
      console.error("Error fetching customer list data:", error);
    },
  });

  const nextPage = () => {
    if (currentPage < data?.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return {
    customerListData: data?.data || initData.data,
    customerListExport: data?.exportData || initData.exportData,
    totalPages: data?.totalPages || initData.totalpages,
    refetch,
    isLoading,
    isRefetching,
    prevPage,
    nextPage,
    setCurrentPage,
    currentPage,
    entries: data?.entries || initData.entries,
    startEntry: data?.startEntry || initData.startEntry,
    endEntry: data?.endEntry || initData.endEntry,
  };
}
